import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var userListByCourseRes;
export const userListByCourseTodo = createAsyncThunk('userListByCourse', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/user_list_filter',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "course_wise": data.course,
                "learning_track": data.track,
                "role_code": data.role,
                "instructor_id": data.instructor,
                "start_date": data.start_date,
                "start_time": data.start_time,
                "end_date": data.end_date,
                "end_time": data.end_time,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return userListByCourseRes = res.data
    } catch (error) {
        return userListByCourseRes = error.response.data
    }
})


const userListByCourseSlice = createSlice({
    name: 'userListByCourse',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(userListByCourseTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('userListByCourse', state.data)
            }
        });
        builder.addCase(userListByCourseTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default userListByCourseSlice.reducer; 